function initFlickityCarousels() {
  const carousels = document.querySelectorAll('.product-card-carousel:not(.flickity-enabled)');
  
  // Détection basée sur la taille d'écran (breakpoint)
  const isMobileViewport = () => {
    return window.innerWidth < 768;
  };

  carousels.forEach(carousel => {
    const isMobile = isMobileViewport();
    
    // Vérifier si le carousel est dans un <scroll-carousel>
    const isInScrollCarousel = carousel.closest('scroll-carousel') !== null;

    
    if (isInScrollCarousel && isMobile) {
      const cells = carousel.querySelectorAll('.carousel-cell');
      cells.forEach((cell, index) => {
        if (index > 0) {
          cell.remove();
        }
      });
      carousel.classList.add('flickity-disabled');
      return;
    }
    
   
    // Désactiver draggable si c'est dans un <scroll-carousel>
    const shouldBeDraggable = isInScrollCarousel ? false : isMobile;

    const flicky = new Flickity(carousel, {
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      prevNextButtons: !shouldBeDraggable,
      wrapAround: false,
      draggable: shouldBeDraggable,
      friction: 0.28,
      freeScrollFriction: 0.075,
      accessibility: true,
      arrowShape: { 
        x0: 30,
        x1: 55, y1: 20,
        x2: 60, y2: 15,
        x3: 40
      },
      dragThreshold: 10,          
      touchVerticalScroll: true 
    });

    // Observer pour recalculer quand visible
    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          flicky.reloadCells();
          flicky.resize();
        }
      });
    }, {
      threshold: 0.1
    });
    intersectionObserver.observe(carousel);

    // Observer le resize du container
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach(entry => {
        flicky.reloadCells();
        flicky.resize();
      });
    });
    resizeObserver.observe(carousel);

   
  });
}

// Recalculer au resize de la fenêtre
window.addEventListener('resize', () => {
  setTimeout(initFlickityCarousels, 100);
});

// Wait for Flickity to load
function waitForFlickity() {
  if (typeof Flickity === 'undefined') {
    setTimeout(waitForFlickity, 100);
    return;
  }
  
  initFlickityCarousels();
}

// Initialize when DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForFlickity);
} else {
  waitForFlickity();
}

// Reinitialize when sections load
document.addEventListener('shopify:section:load', function() {
  setTimeout(initFlickityCarousels, 100);
});

document.addEventListener('products:switched', function(e) {
  setTimeout(initFlickityCarousels, 100);
});

document.addEventListener('swatch:switched', function() {
  setTimeout(initFlickityCarousels, 50);
});

// Periodic check (fallback)
setTimeout(() => {
  initFlickityCarousels();
  setInterval(initFlickityCarousels, 2000);
}, 100);

